import { render, staticRenderFns } from "./contrastSituation.vue?vue&type=template&id=588e23a2&scoped=true"
import script from "./contrastSituation.vue?vue&type=script&lang=js"
export * from "./contrastSituation.vue?vue&type=script&lang=js"
import style0 from "./contrastSituation.vue?vue&type=style&index=0&id=588e23a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e23a2",
  null
  
)

export default component.exports